"use client";

import { useSignUp } from "@clerk/nextjs";
import { useEffect, useLayoutEffect } from "react";
import { observeSignupInteractions } from "@/helpers/observeSignupInteractions";
import { observeSignupCtaClicks } from "@/helpers/observeSignupCtaClicks";
import { clickSignupCta, completeSignup, startSignup } from "@/helpers/signupTracking";

/** Observe actual account creation, never infer signup from a signed-in user. */
export function SignupTracking() {
  const { signUp } = useSignUp();
  useEffect(() => observeSignupInteractions(startSignup), []);
  useEffect(() => observeSignupCtaClicks(clickSignupCta), []);
  // Clerk's client listener can emit before the verification response updates
  // the signup resource. Observe its own signal and capture before redirect.
  useLayoutEffect(() => {
    if (signUp) completeSignup(signUp);
  }, [signUp, signUp?.status, signUp?.createdUserId]);
  return null;
}
